import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, combineLatest } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { ChatsSelectors } from 'src/app/store/samwin/chats/chats.selectors';
import { ChatGuestInfo } from 'src/app/store/samwin/chats/models/chat-guest-info';
import { ChatId } from 'src/app/store/samwin/chats/models/chat-id';
import { ChatMessage } from 'src/app/store/samwin/chats/models/chat-message';
import { RestoreWindow, SetWindowIndex } from 'src/app/store/utility/samweb-window/samweb-window.actions';
import { SamwebWindowState, WindowTypes } from 'src/app/store/utility/samweb-window/samweb-window.state';
import _ from 'lodash';

@Component({
   selector: 'samweb-chat-list-item',
   templateUrl: './chat-list-item.component.html',
   styleUrls: ['./chat-list-item.component.scss'],
})
export class ChatListItemComponent implements OnInit {
   @Input()
   public chatId: ChatId;

   public chatGuestInfo$: Observable<ChatGuestInfo>;
   public numberOfUnreadMessages$: Observable<number | null>;
   public lastMessage$: Observable<ChatMessage | null>;

   public constructor(private readonly store: Store) {
      // nothing to do
   }

   public ngOnInit(): void {
      this.chatGuestInfo$ = combineLatest([
         this.store.select(ChatsSelectors.getChat).pipe(map((getChat) => getChat(this.chatId))),
         this.store.select(ChatsSelectors.getGuestStatus).pipe(map((getStatus) => getStatus(this.chatId))),
      ]).pipe(
         distinctUntilChanged(),
         map(([details, status]) => new ChatGuestInfo(details, status))
      );

      this.numberOfUnreadMessages$ = this.store
         .select(ChatsSelectors.getNumberOfUnreadMessages)
         .pipe(map((getNumberOfUnreadMessages) => getNumberOfUnreadMessages(this.chatId)));

      this.lastMessage$ = this.store.select(ChatsSelectors.getLastMessage).pipe(map((getLastMessage) => getLastMessage(this.chatId)));
   }

   public onClick(): void {
      const maxWindowIdx = this.store.selectSnapshot(SamwebWindowState.getHighestIndex);
      const windowId = _.isNil(this.chatId.uid) ? this.chatId.messageId : this.chatId.uid;
      this.store.dispatch(new SetWindowIndex(WindowTypes.Chat, windowId, maxWindowIdx + 1));
      this.store.dispatch(new RestoreWindow(WindowTypes.Chat, windowId));
   }
}
